import { navigateFromActivity } from "../utils/activityNavigation";

function parseMetadataValue(value) {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (
    (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
    (trimmed.startsWith("[") && trimmed.endsWith("]"))
  ) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return value;
    }
  }
  return value;
}

/**
 * Rebuild a Bond Pulse activity shape from FCM data payload keys.
 */
export function activityFromPushData(data) {
  if (!data || typeof data !== "object") return null;

  const action = data.action ? String(data.action) : "";
  if (!action) return null;

  const metadata = {};
  for (const [key, value] of Object.entries(data)) {
    if (["action", "targetType", "targetId", "link"].includes(key)) continue;
    metadata[key] = parseMetadataValue(value);
  }

  const target =
    data.targetType && data.targetId
      ? { type: String(data.targetType), id: String(data.targetId) }
      : undefined;

  return { action, target, metadata };
}

export function navigateFromPushData(navigate, data) {
  const activity = activityFromPushData(data);
  if (!activity) return false;
  return navigateFromActivity(navigate, activity);
}

export function getPushLinkFromData(data) {
  if (!data?.link) return null;
  return String(data.link);
}

export function handlePushNavigation(navigate, payload) {
  const data = payload?.data || {};
  if (navigateFromPushData(navigate, data)) return true;

  const link = getPushLinkFromData(data);
  if (link && typeof window !== "undefined") {
    try {
      const url = new URL(link, window.location.origin);
      if (url.origin === window.location.origin) {
        navigate(`${url.pathname}${url.search}${url.hash}`);
        return true;
      }
      window.location.assign(link);
      return true;
    } catch {
      return false;
    }
  }

  return false;
}
